var map = {
	"./amagrar_logo.png": 5710,
	"./kulturen/Apfel.png": 3926,
	"./kulturen/Erdbeere.png": 9042,
	"./kulturen/Hafer.png": 3064,
	"./kulturen/Kartoffeln.png": 7909,
	"./kulturen/Möhren.png": 5676,
	"./kulturen/RoteBeete.png": 8322,
	"./kulturen/Sellerie.png": 3015,
	"./kulturen/Sommerweizen.png": 7932,
	"./kulturen/Spargel.png": 908,
	"./kulturen/Winterdurum.png": 2007,
	"./kulturen/Wintergerste.png": 8589,
	"./kulturen/Winterraps.png": 6996,
	"./kulturen/Winterroggen.png": 6463,
	"./kulturen/Wintertriticale.png": 5679,
	"./kulturen/Winterweizen.png": 6528,
	"./kulturen/Zuckerrüben.png": 3522,
	"./kulturen/Zwiebeln.png": 1874,
	"./kulturen/default.png": 1526,
	"./logo.png": 6949,
	"./navigation/Prognosen.png": 8183,
	"./navigation/Rueckmeldung.png": 6774,
	"./navigation/Wetter.png": 6846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;